
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  IScene,
  CustomScene,
  Scene,
  Item,
  state,
  newState,
} from "../scenes/models";
import Loading from "../components/Loading.vue";

const componentSettings = {
  loading: Loading,
  delay: 200,
};


const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

const Inventory = () => ({
  ...componentSettings, 
  component: import(/*webpackChunkName: "Inventory"*/ '../components/Inventory.vue')
})

const Modal = () => ({
  ...componentSettings, 
  component: import(/*webpackChunkName: "Modal"*/ '../components/Modal.vue')
})

const Hints = () => ({
  ...componentSettings, 
  component: import(/*webpackChunkName: "Hints"*/ '../components/Hints.vue')
})

const SceneComponent = () => ({
  ...componentSettings, 
  component: import(/* webpackChunkName: "Scene" */ '../components/Scene.vue')
})
const TitleScene = () => ({
  ...componentSettings,
  component: import(/* webpackChunkName: "TitleScene" */ "../components/TitleScene.vue"),
});
const QuestUnlocked = () => ({
  ...componentSettings,
  component: import(
    /* webpackChunkName: "QuestUnlocked" */ "../components/QuestUnlocked.vue"
  ),
});

const Knockout = () => ({
  ...componentSettings,
  component: import(/* webpackChunkName: "Knockout" */ "../components/Knockout.vue"),
});

const EndCredits = () => ({
  ...componentSettings,
  component: import(/* webpackChunkName: "EndCredits" */ "../components/EndCredits.vue"),
});


@Component<any>({
  components: {
    Inventory,
    TitleScene,
    QuestUnlocked,
    Knockout,
    EndCredits,
    Hints,
    Modal,
    SceneComponent,
    Loading
  },
})
export default class App extends Vue {
  sonny = require("@/images/yang.png");
  play: boolean = false;
  scene: IScene | null = null;
  scenes: any
  showRestart = false;
  showInventory = false;
  showMap = false;
  showHint = false;
  showMenu = false;
  started = false;
  finished = false;
  loading = false;

  restart() {
    localStorage.clear()
    window.location.pathname = "/"
  }

  async goto(next: Promise<IScene>) {
    if (this.scene instanceof Scene) {
      this.scene.audio = null;
      this.scene.description = "";
    }
    this.loading = true
    const nextPage = await next;
    this.scene = nextPage;
    this.loading = false

    if (this.scene instanceof Scene) {
      localStorage.state = JSON.stringify(state);
      localStorage.pageName = nextPage.name;
      this.scene.init();
    }
    this.scene.navigate = this.goto;
  }

  async next() {
    if(this.scene instanceof CustomScene) {
      await this.scene.navigate(this.scene.navigateTo);
      this.scene.key = Math.random();
    }
  }

  async start() {
    const { scenes } = await import("../scenes/scenes");
    this.scenes = scenes
    this.started = true;
    if (!localStorage.pageName) {
      this.goto(scenes.Introduction());
    }
    const pageGetter = scenes[localStorage.pageName];
    if (!pageGetter) {
      this.goto(scenes.Introduction());
    } else {
      const page = await pageGetter();
      page.navigate = this.goto;
      if (page) {
        const { inventory, storylines } = JSON.parse(localStorage.state);
        state.inventory = inventory ? inventory : {};
        state.storylines = storylines ? storylines : {};
        this.goto(pageGetter());
      } else {
        this.goto(scenes.Introduction());
      }
    }
  }


  async mounted() {
    window.addEventListener("keydown", async (e) => {
      if(this.showRestart || this.showInventory || this.showMap || this.showHint) {
        if (e.code == "Escape") {
          e.stopImmediatePropagation();
          this.showRestart = false;
          this.showInventory = false;
          this.showHint = false;
          this.showMap = false;
        }
      }
    });
    await this.start();
  }
}
